import * as signalR from '@microsoft/signalr';

const resolveBaseURL = () => {
  try {
    const { hostname } = window.location;
    if (hostname.includes('localhost')) {
      return 'https://adminrotary.codiatest.com';
    }
    return window.location.origin;
  } catch (e) {
    return 'https://adminrotary.codiatest.com';
  }
};

export const createLiveSurveyConnection = (eventId) => {
  const baseUrl = resolveBaseURL();
  const token = localStorage.getItem('auth.token');
  
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(`${baseUrl}/api/clubevents/hubs/livesurvey`, {
      accessTokenFactory: () => token || '',
    })
    .withAutomaticReconnect({
      nextRetryDelayInMilliseconds: (retryContext) => {
        // Exponential backoff: 0s, 2s, 10s, 30s
        if (retryContext.previousRetryCount === 0) return 0;
        if (retryContext.previousRetryCount === 1) return 2000;
        if (retryContext.previousRetryCount === 2) return 10000;
        return 30000;
      },
    })
    .build();

  return connection;
};

export default createLiveSurveyConnection;

